<div class="education-skill">
  <!-- Hero -->
  <div class="education-skill__hero">
    <div class="vacancy-hero">
      <h1 class="vacancy-hero__title">{{ 'educations.skill.hero_title_prefix' | translate }} {{ skillName }}</h1>
    </div>
  </div>

  <!-- Filters -->
  <div class="education-skill__filters-bar">
    <div class="vacancy-container">
      <div class="vacancy-filters">
        <div>
          <label class="vacancy-filters__label">{{ 'educations.search.filter_categories' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="categorieOptions"
            [control]="categorieControl"
            [placeholder]="'educations.skill.filter_all_categories' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onCategorieSelected($event)"
          ></lib-single-select-search>
        </div>
        <div>
          <label class="vacancy-filters__label">{{ 'educations.search.filter_region' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="regioOptions"
            [control]="regioControl"
            [placeholder]="'educations.skill.filter_all_regions' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onRegioSelected($event)"
          ></lib-single-select-search>
        </div>
        <div>
          <label class="vacancy-filters__label">{{ 'educations.search.filter_learning_form' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="leervormOptions"
            [control]="leervormControl"
            [placeholder]="'educations.skill.filter_all_learning_forms' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onLeervormSelected($event)"
          ></lib-single-select-search>
        </div>
        <div>
          <label class="vacancy-filters__label">{{ 'educations.search.filter_price' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="prijsOptions"
            [control]="prijsControl"
            [placeholder]="'educations.skill.filter_all_prices' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onPrijsSelected($event)"
          ></lib-single-select-search>
        </div>
      </div>
      <div class="vacancy-filters" style="margin-top: 16px;">
        <div>
          <label class="vacancy-filters__label">{{ 'educations.skill.filter_providers' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="aanbiederOptions"
            [control]="aanbiederControl"
            [placeholder]="'educations.skill.filter_all_providers' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onAanbiederSelected($event)"
          ></lib-single-select-search>
        </div>
        <div>
          <label class="vacancy-filters__label">{{ 'educations.search.filter_subsidy' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="subsidieOptions"
            [control]="subsidieControl"
            [placeholder]="'educations.skill.filter_all_educations' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onSubsidieSelected($event)"
          ></lib-single-select-search>
        </div>
        <div>
          <label class="vacancy-filters__label">{{ 'educations.search.filter_start_date' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="startDatumOptions"
            [control]="startDatumControl"
            [placeholder]="'educations.skill.filter_all_start_dates' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onStartDatumSelected($event)"
          ></lib-single-select-search>
        </div>
        <div>
          <label class="vacancy-filters__label">{{ 'educations.search.filter_language' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="taalOptions"
            [control]="taalControl"
            [placeholder]="'educations.skill.filter_all_languages' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onTaalSelected($event)"
          ></lib-single-select-search>
        </div>
      </div>
    </div>
  </div>

  <!-- Results -->
  <div class="vacancy-container education-skill__content">
    <div class="vacancy-grid">
      <bwc-education-card
        *ngFor="let education of visibleEducations"
        [education]="education"
        [isLiked]="isLiked(education.id)"
        (liked)="toggleLike($event)"
      ></bwc-education-card>
    </div>

    <div class="vacancy-load-more" *ngIf="hasMore">
      <button (click)="loadMore()">{{ 'shared.load_more' | translate }}</button>
    </div>
  </div>
</div>
